<template>
  <div class="classContainer">
    <van-nav-bar
      title="评价学员"
      left-span=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <div class="contain">
      <div class="list-contain">
        <div class="table">
          <div class="table-item thead">
            <div class="left">评价项目</div>
            <div class="right">得分</div>
          </div>
          <div class="table-item" v-for="(item,index) in tableInfo" :key="index">
            <div class="left">{{item.ratingItem}}</div>
            <div class="right" @click="select(item,index)">
              <!-- <uni-data-select
                :disabled="ratingCriteriaStatus == '1'"
                :clear="false"
                v-model="item.ratingCriteriaScore"
                :localdata="getLocaldata(item.score)"
              ></uni-data-select> -->
              <span class="" v-if="item.ratingCriteriaScore">{{ item.ratingCriteriaScore }}</span>
              <span class="" v-else>
                请选择
              </span>
            </div>
          </div>
        </div>
        <div class="center">
          <div class="center-info">
            <span class="center-info-label">评价对象：</span>
            <span class="center-info-value">
              {{userName}}
            </span>
          </div>
          <div class="center-info">
            <span class="center-info-label">总得分：</span>
            <span class="center-info-value">{{scoreSum}}</span>
          </div>
          <div class="center-info" v-if="ratingCriteriaStatus == '1'">
            <span class="center-info-label">评价人：</span>
            <span class="center-info-value">{{evaluateName}}</span>
          </div>
          <div class="center-info" v-if="ratingCriteriaStatus == '1'">
            <span class="center-info-label">评价时间：</span>
            <span class="center-info-value">{{evaluateTime}}</span>
          </div>
        </div>
      </div>
      <div class="bottom" v-if="ratingCriteriaStatus == '0'">
        <div class="bottom-inner" @click="evaBatch">
          批量评价
        </div>
        <div class="bottom-inner primary" @click="submit">
          提交
        </div>
      </div>
    </div>
    <van-popup v-model="showBatchScore" position="bottom">
      <van-picker
        ref="myPicker"
        show-toolbar
        :columns="columns"
        @cancel="showBatchScore = false"
        @confirm="confirmBatchScore"
      />
    </van-popup>
  </div>
</template>

<script>
import {saveCriteria, teachingPlandetailById, teachingPlanRatingCriteria} from "@/api/classSchedule";
import { Message } from 'element-ui'
export default {
  name: "ratingScale",
  data() {
    return {
      userName:'',
      userId:'',
      planDetailId:'',
      ratingCriteriaId:'1940325825589809154',
      evaluateName:'',
      evaluateTime:'',
      ratingCriteriaStatus:'',//0待评价，1已评价
      tableInfo:[],
      maxScore:'',
      batchScore:'',
      showBatchScore:false,
      isBatch:false,
      currentDataIndex:-1,
      columns:[],
      criteriaInstanceId:''
    }
  },
  computed: {
    scoreSum(){
      let sum = this.tableInfo.reduce((sum,item)=>{
        return sum +item.ratingCriteriaScore
      },0)
      return sum
    }
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1)
    },
    //未评价获取评价表
    async getData(){
      let res = await teachingPlanRatingCriteria(this.ratingCriteriaId);
      this.ratingCriteriaDetails = res.data.ratingCriteriaDetails
      let datas = res.data.ratingCriteriaDetails;
      const leafNodes = this.getLeafNodes(datas);
      this.tableInfo = leafNodes;
      this.maxScore = Math.max(...this.tableInfo.map(item => item.score));
    },
    //已评价获取详情
    async getDetail(){
      let res = await teachingPlandetailById({
        planDetailId:this.planDetailId,
        userId:this.userId,
        ratingCriteriaId:this.ratingCriteriaId
      });
      let datas = res.data.ratingCriteriaDetails;
      this.evaluateName = res.data.evaluateName;
      this.evaluateTime = res.data.evaluateTime;
      const leafNodes = this.getLeafNodes(datas);
      this.tableInfo = leafNodes;
    },
    select(item,index){
      if(this.ratingCriteriaStatus == '1'){
        return
      }
      this.showBatchScore = true
      this.currentDataIndex = index
      this.isBatch = false;
      this.columns = this.getLocaldata(item.score)
      // this.$refs.myPicker.setIndexs([0])
    },
    //批量评价
    evaBatch(){
      console.log('批量评价')
      this.isBatch = true
      this.batchScore = ''
      this.showBatchScore = true
      this.columns = this.getLocaldata(this.maxScore)
      // this.$refs.myPicker.setIndexs([0])
    },
    //取出扁平化数组最子级的数据
    getLeafNodes(arr){
      // 创建一个 Map 存储所有有子节点的 id
      const parentMap = arr.reduce((map, item) => {
        if (item.pid !== '0') {
          map.set(item.pid, true);
        }
        return map;
      }, new Map());

      // 返回不在 parentMap 中的节点
      return arr.filter(item => !parentMap.has(item.id));
    },
    //设置标准分
    getLocaldata(num){
      return Array.from({length: num}, (_, index) => (num - index));
    },
    //批量评分
    confirmBatchScore(e){
      if(this.isBatch){
        for(var val of this.tableInfo){
          if(val.score>=e){
            val.ratingCriteriaScore = e
          }else{
            val.ratingCriteriaScore = val.score
          }
        }
      }else{
        this.tableInfo[this.currentDataIndex].ratingCriteriaScore = e
      }
      this.closeBatchScore()
    },
    //取消批量评分
    closeBatchScore(){
      this.showBatchScore = false
    },
    //将扁平化数组转成树结构数组
    arrayToTree(items) {
      const result = []; // 存放结果集
      const itemMap = {}; // 存放所有节点的映射表

      // 先转成map存储
      for (const item of items) {
        itemMap[item.id] = {
          ...item,
          children: []
        };
      }

      for (const item of items) {
        const id = item.id;
        const pid = item.pid;
        const treeItem = itemMap[id];

        if (pid === "0") {
          // 根节点
          result.push(treeItem);
        } else {
          // 非根节点，找到父节点并添加到其children中
          if (itemMap[pid]) {
            itemMap[pid].children.push(treeItem);
          }
        }
      }

      return result;
    },
    async submit(){
      let flagArr = this.tableInfo.filter(item=>item.ratingCriteriaScore == null);
      if(flagArr.length>0){
        Message({ message: "评分项项目分数不能为空", type: 'warning',customClass:'classMessage'})
        return
      }
      for(var val of this.ratingCriteriaDetails){
        for(var item of this.tableInfo){
          if(val.id == item.id){
            val.ratingCriteriaScore = item.ratingCriteriaScore
          }
        }
      };
      let treeNodes = this.arrayToTree(this.ratingCriteriaDetails);
      let params = {
        planDetailId:this.planDetailId,
        ratingId:this.ratingCriteriaId,
        score:this.scoreSum,
        treeNodes:treeNodes,
        businessDTOS:[{evaluateObjectId:this.userId,planDetailId:this.planDetailId,businessId:this.userId}]
      }
      let res = await saveCriteria(params);
      this.$router.go(-1)
    }
  },
  mounted() {
    this.ratingCriteriaId = this.$route.query.ratingCriteriaId;
    this.criteriaInstanceId = this.$route.query.criteriaInstanceId;
    this.planDetailId = this.$route.query.planDetailId;
    this.userId = this.$route.query.userId;
    this.userName = this.$route.query.userName;
    this.ratingCriteriaStatus = this.$route.query.ratingCriteriaStatus;
    if(this.ratingCriteriaStatus == '1'){
      //已评价
      this.getDetail()
    }else{
      //未评价
      this.getData()
    }
  },
}
</script>
<style scoped lang="scss">
::v-deep .van-nav-bar .van-icon{
  color: #2F2F46
}
.contain{
  padding: 0 16px 16px 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .list-contain{
    flex: 1;
    overflow: scroll;
    .table{
      color: #333333;
      // margin-bottom: 124rpx;
      font-size: 12px;
      &-item{
        display: flex;
        min-height: 48px;
        border-left: 1px solid #DDDDDD;
        &.thead{
          display: flex;
          background-color: #3776FF;
          color: #fff;
          border-radius: 10px 10px 0 0;
          font-size: 16px;
          font-weight: 600;
          div{
            line-height: 48px;
            text-align: center;
            border-right: none;
            font-size: 16px;
            color: #fff !important;
            &:first-child{
              border-right: 1px solid #DDDDDD;
              text-align: center !important;
              justify-content: center;
            }
            &:last-child{
              font-size: 16px;
            }
          }
        }
        div{
          border-bottom: 1px solid #DDDDDD;
          border-right: 1px solid #DDDDDD;
          text-align: center;
          // display: flex;
          // justify-content: center;
          align-items: center;
          &.left{
            &:last-child{
              border-bottom: none;
            }
            text-align: left;
            flex: 1;
            font-size: 14px;
            padding: 10px;
            line-height: 20px;
            display: flex;
            justify-content: flex-start;
          }
          &.right{
            padding: 10px;
            flex: 0 0 100px;
            justify-content: center;
            align-items: center;
            display: flex;
            &.disabled{
              pointer-events: none;
            }
          }
        }
      }
    }
  }
  .center{
    .center-info{
      padding: 10px 0;
      display: flex;
      font-size: 14px;
      justify-content: space-between;
      align-items: center;
      color: #333333;
      border-bottom: 1px solid #f5f5f5;
    }
  }
  .bottom{
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .bottom-inner{
    width: 150px;
    height: 44px;
    line-height: 44px;
    border-radius: 22px;
    color: #2F2F46;
    border: 1px solid #ccc;
    text-align: center;
    font-size: 16px;

    &.primary{
      color: #ffffff;
      background-color: #3776FF;
    }
  }
}
</style>
